export default __webpack_public_path__ + "static/media/corsi-di-formazione-nc.b8887516.svg";